"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Theme_1 = require("./Theme");
var IconButton_1 = require("@material-ui/core/IconButton");
exports.default = (function (_a) {
    var onClick = _a.onClick, _b = _a.color, color = _b === void 0 ? "primary" : _b, icon = _a.icon, _c = _a.ariaLabel, ariaLabel = _c === void 0 ? "" : _c, className = _a.className;
    return (React.createElement(Theme_1.default, { color: color },
        React.createElement(IconButton_1.default, { className: className, color: color, "aria-label": ariaLabel, onClick: onClick },
            React.createElement("i", { className: "fa-".concat(icon, " fal fa-1x") }))));
});
//# sourceMappingURL=FormControlIconButton.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/components/dist/theme/mdb/FormControlIconButton.js
// module id = 2220
// module chunks = 0